/* script */
//
//
//
//
//
//
//

// Utils
import { clone, isArray } from 'lodash';
import semver from 'semver';

// Constants
const AVAILABLE_TARGETS = ['route', 'window'];

// Custom actions
import CancelMeetingButton from 'ui/components/meetings/CancelMeetingButton.vue';
import OpenInWebappButton from 'ui/components/OpenInWebappButton.vue';

const __vue_script__ = {
    name: 'CustomActionButton',

    components: {
        CancelMeetingButton,
        OpenInWebappButton
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        action: {
            type: Object,
            required: true
        },

        context: {
            type: Object,
            required: true
        }
    },

    data() {
        let label = this.$i18n.t('generic_form.custom_actions.gerenric_button', [this.action._name]).toString();
        if (this.action.label) {
            label = this.$utils.locales.translateWithContext(this.action.label, this.context, this.$i18n);
        }

        return {
            enabled: false,
            label
        };
    },

    created() {
        const action = clone(this.action);
        let hasPermission = true;
        let hasAction = true;

        if (action.service && action.method) {
            const $injector = angular.element(document).injector();

            if (!$injector.has(action.service)) {
                console.error(`[CustomActionButton] service does not exist: ${action.service}`);
                return;
            }

            if (typeof $injector.get(action.service)[action.method] !== 'function') {
                console.error(`[CustomActionButton] service ${action.service} does not have method ${action.method}`);
                return;
            }
        }

        if (isArray(action.permissions) && semver.gt(this.event.versionEventDoc, '3.4.1')) {
            hasPermission = action.permissions.every(permission => this.$services.user.hasPermission(permission, {
                event_id: this.event._id,
                org_id: this.event.ownerId
            }));
        }

        if (hasAction && hasPermission) {
            this.enabled = true;
        }
    },

    methods: {
        run() {
            if (this.action.service && this.action.method) {
                const $injector = angular.element(document).injector();
                const service = $injector.get(this.action.service);
                service[this.action.method](this.context);

            } else if (Array.from(AVAILABLE_TARGETS).includes(this.action.target)) {

                const route = this.$utils.url.interpolateUrl(this.action.route, { ...this.context, eventId: this.event._id });
                this.$services.router.openRoute(route, this.action.target || 'bstg-internal-route-frame');
            } else if (this.action.appscriptUrl) {
                this.$services.appScripts.callAppScript(
                    this.event._id,
                    this.action.appscriptUrl,
                    this.$utils.strings.compileWithObjectDeep(this.action.appscriptParams || {}, this.context)
                );
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('div',{staticClass:"custom-action"},[(_vm.action.component)?_c(_vm.action.component,_vm._g({tag:"component",attrs:{"event":_vm.event,"action":_vm.action,"context":_vm.context}},_vm.$listeners)):_c('button',{staticClass:"custom-action btn",class:_vm.action.class || 'btn-default',attrs:{"type":"button"},on:{"click":_vm.run}},[_vm._v(_vm._s(_vm.label))])],1):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CustomActionButton.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__